"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Warehouse {
    constructor(data) {
        this.coverageForGoodsInStorage = data.coverageForGoodsInStorage;
        this.scheduleOfValuesFile = data.scheduleOfValuesFile;
        this.locations = data.locations;
        this.storageLossesLastFiveYears = data.storageLossesLastFiveYears;
    }
    static empty() {
        const data = {
            coverageForGoodsInStorage: undefined,
            scheduleOfValuesFile: undefined,
            locations: [],
            storageLossesLastFiveYears: false
        };
        return new Warehouse(data);
    }
    static fromObj(data) {
        if (!data) {
            return Warehouse.empty();
        }
        return new Warehouse(Object.assign({}, data));
    }
    validate() {
        const errors = [];
        const { scheduleOfValuesFile, locations, storageLossesLastFiveYears, coverageForGoodsInStorage } = this;
        if (typeof storageLossesLastFiveYears !== "boolean")
            errors.push("Wrong type for storageLossesLastFiveYears");
        if (typeof coverageForGoodsInStorage !== "boolean")
            errors.push("Wrong flag coverage for goods in storage");
        if (coverageForGoodsInStorage) {
            if (!(scheduleOfValuesFile === null || scheduleOfValuesFile === void 0 ? void 0 : scheduleOfValuesFile.documentPath) &&
                (!Array.isArray(locations) || !locations.length))
                errors.push("Wrong locations array (at least one location is required)");
        }
        return errors;
    }
}
exports.default = Warehouse;
//# sourceMappingURL=warehouse.class.js.map